import CN from "classnames"
import "./Button.css"

const Button = ({ onClick, text, filled, outlined, disabled, link }: {
  onClick: () => void,
  text?: string,
  filled?: boolean,
  outlined?: boolean,
  disabled?: boolean,
  link?: boolean,
}) => {
  return (
    <button
        type="button"
        className={CN(
          'button',
          { 'button-filled': filled },
          { 'button-filled-disabled': disabled },
          { 'button-outlined': outlined },
          { 'button-link': link },
        )}
        onClick={onClick}
        disabled={disabled}
      >
        {text}
      </button>
  )
}

export default Button